export default __webpack_public_path__ + "138e039b53f2e348d15df0fa6410574b.png";